import React, { useRef, useState } from 'react';
import { Camera, X } from 'lucide-react';

const ImageSection = ({ images, title, onImageUpload, onCameraClick }) => {
  const fileInputRef = useRef(null);
  const [showFullImage, setShowFullImage] = useState(false);

  const handleCameraClick = () => {
    // Si hay un handler externo para el clic de la cámara, usarlo
    if (onCameraClick) {
      onCameraClick();
      return;
    }
    // Si no, comportamiento por defecto: abrir el selector de archivos
    fileInputRef.current?.click();
  };

  return (
    <>
      <div className="relative">
        {images.length > 0 ? (
          // Si hay imagen, mostrarla
          <>
            <img
              src={images[0]}
              alt={title}
              className="w-full h-48 object-cover cursor-pointer"
              onClick={() => setShowFullImage(true)}
            />
            {/* Botón flotante de cámara */}
            <button 
              onClick={handleCameraClick}
              className="absolute bottom-4 right-4 p-2 bg-black dark:bg-white bg-opacity-50 dark:bg-opacity-30 rounded-full text-white dark:text-gray-900 hover:bg-opacity-70 dark:hover:bg-opacity-50 transition-colors"
            >
              <Camera className="w-5 h-5" />
            </button>
          </>
        ) : (
          // Si no hay imagen, mostrar un botón grande con cámara y texto
          <button 
            onClick={handleCameraClick}
            className="w-full h-48 bg-gray-100 dark:bg-gray-800 flex flex-col items-center justify-center gap-2 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <Camera className="w-8 h-8 text-gray-500 dark:text-gray-400" />
            <span className="text-gray-600 dark:text-gray-300">Cargar una foto a este lote</span>
          </button>
        )}

        {/* Input oculto para subir archivos */}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={onImageUpload}
        />
      </div>

      {/* Modal para ver la imagen en grande */}
      {showFullImage && images.length > 0 && (
        <div 
          className="fixed inset-0 bg-black dark:bg-gray-900 bg-opacity-75 dark:bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setShowFullImage(false)}
        >
          <div className="relative max-w-3xl w-full">
            <button 
              onClick={() => setShowFullImage(false)}
              className="absolute -top-10 right-0 text-white hover:text-gray-300 dark:hover:text-gray-400"
            >
              <X className="w-6 h-6" />
            </button>
            <img
              src={images[0]}
              alt={title}
              className="w-full h-auto rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default ImageSection; 